import axios from 'axios'
import { i18n } from '../../plugins/i18n'

export const companiesReplyTemplates = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    templatesForReviews: {},
  },
  mutations: {
    readReplyTemplates(state) {
      state.data = null
      state.loading = true
    },
    deleteReplyTemplate(state) {
      state.loading = true
    },
    readReplyTemplatesSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
    },
    deleteReplyTemplatesSuccess(state, reply_template_id) {
      state.data = state.data.filter((value) => {
        return value.id !== reply_template_id
      })
      state.loading = false
    },
    readReplyTemplatesForReview(state) {
      state.loading = true
    },
    readReplyTemplatesForReviewSuccess(state, payload) {
      state.templatesForReviews[payload.reviewUuid] = payload.data
      state.loading = false
    },
    apiFailure(state) {
      state.loading = false
    }
  },
  actions: {
    readReplyTemplates({ commit, rootState }) {
      commit('readReplyTemplates')
      axios
        .get('/api/companies/' + rootState.route.params.company_uuid + '/reply_templates.json')
        .then(res => {
          commit('readReplyTemplatesSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure')
          console.error(err)
        })
    },
    deleteReplyTemplate({ commit, rootState }, { reply_template_id }) {
      commit('deleteReplyTemplate')
      axios
        .delete('/api/companies/' + rootState.route.params.company_uuid + '/reply_templates/' + reply_template_id)
        .then(() => {
          commit('deleteReplyTemplatesSuccess', reply_template_id)
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.deleted', { value: i18n.t('models.replyTemplate.modelName') }) }, { root: true })
        })
        .catch(err => {
          commit('apiFailure')
          console.error(err)
        })
    },
    readReplyTemplatesForReview({ commit, rootState }, id) {
      commit('readReplyTemplatesForReview')
      axios
        .get(`/api/companies/${ rootState.route.params.company_uuid }/reviews/${ id }/reply_templates.json`)
        .then(res => {
          const payload = { data: res.data, reviewUuid: id }
          commit('readReplyTemplatesForReviewSuccess', payload)
        })
        .catch(err => {
          commit('apiFailure')
          commit('flash/updateFlash', { type: 'alert', message: err.response.data.errors[0].detail }, { root: true })
        })
    },
  }
}
